import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/diveAN/step2';
import { Annulation } from '../models/Annulation';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { CTRL_499 } from '../../../validators/499/ctrl499';
@Component({
  selector: 'app-type-desc-marche',
  templateUrl: './type-desc-marche.component.html'
})
export class TypeDescMarcheComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeDescMarche'
  @Input() parentForm: FormGroup;
  @Input() annulation: Annulation;
  @Input() disabled: boolean;

  public step2 = new Step2();
  public rg2 = CTRL_268.id + '_2';
  public rg3 = CTRL_268.id + '_3';
  public rg4 = CTRL_268.id + '_4';
  public rg5 = CTRL_499.id + '_1';

  // TODO MBO en attente retour AIFE champs nature Marche
  // public readonly travauxValue = RadioCheckBoxEnum.travauxValue;
  // public readonly fournituresValue = RadioCheckBoxEnum.fournituresValue;
  // public readonly servicesValue = RadioCheckBoxEnum.servicesValue;

  // public radioButtonValue: string;
  // public radioButtonCtrlName: string;

  constructor() { }

  public ngOnInit() {
    // TODO MBO en attente retour AIFE champs nature Marche
    // if (this.annulation?.description?.natureMarche?.fournitures === RadioCheckBoxEnum.emptyValue) {
    //   this.radioButtonValue = this.fournituresValue;
    // } else if (this.annulation?.description?.natureMarche?.services === RadioCheckBoxEnum.emptyValue) {
    //   this.radioButtonValue = this.servicesValue;
    // } else {
    //   this.radioButtonValue = this.travauxValue;
    // }
    // this.radioButtonCtrlName = this.getUid() + '_SepAtt_travaux';
    this.parentForm.addControl(this.getStepId() + this.rg5, new FormControl({ rgCtrls: this.getCtrl_499Names_json() }));
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  cbChecked() {
    if (this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB']?.value) {
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_268_3Names_json() }));
    } else {
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_268_1Names_json() }));
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_268_2Names_json() }));
    }
    return this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB']?.value;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268_1Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_2Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_3Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuExecutionLivraison_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeLieu_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  public getCtrl_499Names_json(): any {
    const descObjetPrinCp = '_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale';
    const descObjetPrinCs = '_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classSupplementaire';
    const objetCompCp = '_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_INDEX_499_1_SepSep_TypeCPVClass_SepAtt_classPrincipale';
    const objetCompCs = '_SepSep_Annulation_SepSep_TypeDescMarche_SepSep_TypeObjCPV_index_INDEX_499_1_SepSep_TypeCPVClass_SepAtt_classSupplementaire';
    return { objetPrinCp: descObjetPrinCp, objetPrinCs: descObjetPrinCs, objetCompCp, objetCompCs };
  }

}

